import { getVariant } from './experimentClient';
import type { FEATURES } from './features';

export type FeatureFlagKey = (typeof FEATURES)[keyof typeof FEATURES];

export function useFeatureFlag(flagKey: FeatureFlagKey, defaultValue = 'off') {
  const value = getVariant(flagKey, defaultValue);

  return {
    enabled: value === 'on',
  };
}
